
import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from '../../components/ProgressiveImage';

function Image({ src, alt, className, placeholder, style, ...props }) {
    return (
      <div className={className}>
        <ProgressiveImage
          className="Image"
          src={src}
          alt={alt}
          placeholder={placeholder}
          showPlaceholder={!!placeholder} // Only show placeholder if one is provided
          style={style}
          {...props}
        />
      </div>
    );
}

Image.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    placeholder: PropTypes.string,
    style: PropTypes.object,
};

Image.defaultProps = {
    alt: 'Image',
    placeholder: '',
    style: {},
};

export default Image;